export default "__VITE_ASSET__CH2oeXG3__"